module.exports = __webpack_public_path__ + "static/media/QuestionSignIcon.02643e3b.svg";